import { render } from "./Paginator.vue?vue&type=template&id=2c53127a"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"
script.render = render

export default script